export var CVV_TOOLTIP_TEST_ID = 'cvv-tooltip-test-id';
export var QUESTION_CIRCLE_FILL_ICON_TEST_ID = 'question-circle-fill-icon-test-id';
export var CVV_SUBHEADING_VISA = 'Mastercard/Visa/Discover:';
export var THREE_DIGIT_CODE = '3-digit security code';
export var CVV_SUBHEADING_AMEX = 'American Express:';
export var FOUR_DIGIT_CODE = '4-digit security code';
export var CVV_SUBCONTAINER_VISA_TEST_ID = 'cvv-subcontainer-visa-test-id';
export var CVV_SUBCONTAINER_AMEX_TEST_ID = 'cvv-subcontainer-amex-test-id';
export var FIND_YOUR_CVV = 'Find your CVV';
export var VISA_CARD_ALT_TEXT = 'mastercard/visa/discover card cvv';
export var AMEX_CARD_ALT_TEXT = 'amex card cvv';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/PaymentForm/constants.js
// module id = 1504
// module chunks = 11